export const APPROVAL_AMOUNT = '1000000000000000000000000';
